<template>
  <div class="rules-prizes" :class="{ 'rules-prizes--center': center }">
    <ul ref="carousel" class="rules-prizes__list owl-carousel">
      <li
        v-for="(prize, i) in prizes"
        :key="i"
        class="rules-prizes__item"
      >
        <img :src="prize" class="rules-prizes__img" alt="">
      </li>
    </ul>
    <div class="rules-prizes__btn">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prizes: {
      type: Array,
      default: () => []
    },
    center: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      const { carousel } = this.$refs

      /* eslint-disable */
      this.owl = $(carousel).owlCarousel({
        pullDrag: false,
        loop: true,
        responsive: {
          0: {
            items: 1,
            dots: true
          },
          768: {
            items: 3,
            dots: false
          }
        }
      })
      /* eslint-enable */
    })
  }
}
</script>

<style lang="scss" scoped>
  .rules-prizes {
    text-align: center;

    @include media-down(md) {
      &--center {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        transform: translateY(-50%);
      }
    }

    &__list {
      @include reset-list;
      padding: 2.5 * 18px 0 0;
      max-width: 990px;
      width: 100%;
      margin: 0 auto;

      @include media-up(md) {
        pointer-events: none;
      }
    }

    &__item {
      display: flex;
      align-items: center;
      height: 100%;

      @include media-down(md) {
        padding: 0 45px;
      }
    }

    &__img {
      @include responsive-img;
      max-height: 210px;
      width: auto !important;
      user-select: none;

      @include media-down(md) {
        margin: 0 auto;
      }

      @include media-up(md) {
        height: 170px;
      }

      @include media-up(lg) {
        height: 210px;
      }
    }

    &__btn {
      margin-top: 24px;

      display: flex;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/ContestPrizes/ContestPrizes.vue